import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6AB2A77F-C9ED-4EF1-BDD3-4E060E690A7E
 * name star-check
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-check.svg
 * tags
 * - Shape 
 */
export const StarCheckIcon = createSvgIcon(<><path d="M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M17.8 21.2L22.6 16.4L21.3 15L17.7 18.6L16.2 17L15 18.2L17.8 21.2" /></>, 'StarCheckIcon');
export default StarCheckIcon